import React from "react";
import { Link, DisabledPrompt, useParams, useBCMSContext, BCMSRecord, useRoute } from "@bcm-dev/bcms-vite";
import Classes, { Card } from "model";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { SVGAsset } from "res";
import { UIPrimaryButton } from "components/ui/UIButton";

import "./styles.css";

/**
 * @function ActivateCardPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ActivateCardPage
 */
export default function ActivateCardPage(props) {
    //const controller = useBCMSContext();
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, controller);

    const cardID = useParams().cardID;
    const card = Card.initByID(cardID);

    const type = card.type.charAt(0).toUpperCase() + card.type.slice(1);
    const number = card.maskedNumber;

    const navigate = useRoute();
    const doneBtn = evt => navigate(`/home/recenttransactions/${ cardID }`);

    return (
        <MainContentContainer
            className="activate-card-page"
            header={
                <MainContentHeader text="Activate Card" />
            }>
            <div className="activate-card-view text-center">
                <div className="framed-icon-container">
                    <SVGAsset id="OutlineCardIcon" className="card-icon" />
                    <SVGAsset id="CheckmarkCircleIcon" className="CheckmarkCircleIcon" />
                </div>
                <p><b>Your card has been activated</b></p>
                <p>{ type } ending in { number } is active and ready to use.</p>
                <p>Set PIN to use your card for ATM cash withdrawals and purchases with merchants who require a PIN.</p>
                <span>Have any questions? <DisabledPrompt><Link>Contact Us</Link></DisabledPrompt></span>
                <Link to={ `/home/securitytoken/receivetoken/${ cardID }/setpin` } className="flex-container flex-horizontal align-center-container set-pin-container">
                    <div className="set-width">
                        <SVGAsset id="PinIcon" className="pin-icon" />
                    </div>
                    <div className="flex-width text-left">
                        <span data-point="Activate_Card_Set_Pin">Set PIN</span>
                    </div>
                    <div className="set-width">
                        <SVGAsset id="RightChevronIcon" className="right-chevron-icon chevron-icon" />
                    </div>
                </Link>
                <UIPrimaryButton text="Done" onClick={ doneBtn } />
            </div>
        </MainContentContainer>
    )
}
